export const adap_producto = ({producto}) => {

    let obj = {
        id: producto.id,
        nombre: producto.nombre,
        marca: producto.marca,
        cantidad: 1,
        presentacion: producto.presentacion,
        valor: producto.valor,
        valorAntes: producto.valorAntes ? producto.valorAntes : '',
        img: producto.img ? producto.img : ''
    }

    return obj

}